<template>
    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 48 48">
        <path
            fill="#ff1744"
            d="M24,4C12.947,4,4,12.947,4,24s8.947,20,20,20s20-8.947,20-20S35.053,4,24,4z M24,39c-5.263,0-10-6.896-10-15S18.737,9,24,9s10,6.896,10,15S29.263,39,24,39z"
        ></path>
        <path
            fill="#d50000"
            d="M36.564,8.445C34.413,6.972,31.89,6,29.263,6c-3.948,0-7.524,1.98-10.166,5.079C20.573,9.77,22.255,9,24,9c5.263,0,10,6.896,10,15s-4.737,15-10,15c-1.745,0-3.427-0.77-4.903-2.079C21.739,40.02,25.315,42,29.263,42c2.626,0,5.15-0.972,7.3-2.444C41.097,35.891,44,30.29,44,24C44,17.711,41.097,12.11,36.564,8.445z"
        ></path>
    </svg>
</template>
<script>
export default {
    name: "OperaIcon",
};
</script>
<style scoped></style>
